<template>
<div class="friend-list-wrapper">
    <div class="friend-list-container">
    <div class="title">
      Friend List
    </div>
    <div class="friend-list" v-if="(user && !friendsCount && loaded) || !user">
      <p>
        Seems like you haven't received <br />any
        <span>Friend Points </span> yet :(
      </p>
    </div>

    <div class="friend-list" v-if="!loaded">
      Loading...
      <br />
    </div>

    <div class="friend-list" v-if="user && friendsCount && loaded">
      <p>
        Nice! You've received <span>{{ pointsReceived }}</span> Friend Points
        <i class="fas fa-users"></i> from <span>{{ friendsCount }}</span>
        {{ friendsCount > 1 ? "friends" : "friend" }}:
      </p>
      <p class="smaller">
        <ol>
          <li
            v-for="(entry, i) in bonusPointsReceivedByTrimmed"
            :key="entry.from"
          >
            {{ entry.from }} <span>{{ entry.points }}</span
            >{{ i === bonusPointsReceivedByTrimmed.length - 1 ? "" : "," }}
          </li>
        </ol>
      </p>
    </div>
    <div class="share-button-wrapper">
      Share to get started and increase your chances of winning!
      <a class="img-a-button" @click="openShareModal()">
        <img src="@/assets/btn-yes.png" alt="Open share dialog" />
      </a>
    </div>
    
  </div>
</div>
</template>

<script>
import { db } from "@/main.js";
import firebase from "firebase";
import ShareModal from "@/components/shared/ShareModal";

// <ShareModal :currentUser="currentUser" :totalScore="totalScore" />
export default {
  props: ["currentUser", "totalScore"],
  data() {
    return {
      friendsCount: 0,
      pointsReceived: 0,
      hasReceivedPoints: false,
      user: null,
      loaded: true,
      bonusPointsReceivedBy: []
    };
  },
  computed: {
    bonusPointsReceivedByTrimmed() {
      return this.bonusPointsReceivedBy.slice(0, 15);
    }
  },
  methods: {
    openShareModal() {
      this.$modal.show("share-modal", {
        currentUser: this.currentUser,
        totalScore: this.totalScore
      });
    },
    fetchBonusPointsList() {
      db.collection("Users")
        .doc(this.user.uid)
        .collection("bonusPointsReceivedBy")
        .where("points", ">=", 0)
        .onSnapshot(snap => {
          const bonusPoints = [];
          snap.forEach(doc => bonusPoints.push(doc.data()));
          bonusPoints.sort((a, b) => b.points - a.points);

          this.pointsReceived = bonusPoints.reduce(
            (acc, cur) => acc + cur.points,
            0
          );
          this.bonusPointsReceivedBy = bonusPoints;
          this.friendsCount = snap.size;
          this.loaded = true;
        });
    }
  },
  mounted() {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.user = user;
        this.loaded = false;
        this.fetchBonusPointsList();
        unsubscribe();
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.share-button-wrapper {
  margin-top: 25px;
  a {
    margin: 0px;
  }
}

.friend-list-wrapper {
  max-width: 475px;
}

.friend-list-container {
  text-align: center;
  .title {
    margin-bottom: 30px;
  }
  .friend-list {
    text-align: center;
    font-size: 11px;
    max-width: 710px;
    p {
      margin: 30px 0 20px 0;
    }
    span {
      color: $accent-color;
    }

    .smaller {
      margin-top: 10px;
      font-size: 0.9em;
      ol {
        list-style: none;
        li {
          display: inline-block;
          margin-left: 4px;
        }
      }
    }
  }
}
.fa-users {
  font-size: 1rem;
  margin-left: -5px;
  margin-bottom: 1px;
}

.share-button-wrapper {
  font-size: 0.725rem;
  background: #231b4d;
  border-radius: 20px;
  padding: 20px;
  a {
    margin-top: 25px;
    display: block;
  }
}

@media (max-width: 768px) {
  .friend-list-container .title {
    text-align: center;
  }
}
</style>